export default __webpack_public_path__ + "static/media/box_package.ca2a8a1e.svg";